module.exports = __webpack_public_path__ + "img/price-tag-2-line.72423862.svg";